import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "credit-cards",
  "use": "credit-cards-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"credit-cards\"><path fill-rule=\"evenodd\" d=\"M21 5H7v2h14V5Zm0 5H7v5h14v-5Zm2-5v10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5c0-1.11.89-2 2-2h14a2 2 0 0 1 2 2ZM3 19h15v2H3a2 2 0 0 1-2-2V8h2v11Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol